import { Control } from "ol/control";

export default abstract class CustomControl extends Control {
    constructor(element: HTMLElement) {
        super({
            element
        })
        this.addEvents(element)
    }
    abstract addEvents(element: HTMLElement): void
}